import { Box } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

export default function ScreenWrap({ children }: Props) {
  return <Box sx={{ p: 4, width: '100%', overflow: 'auto' }}>{children}</Box>;
}
